<div class="min-h-screen bg-gray-50 dark:bg-gray-900 pb-6">
  <!-- Loading -->
  <div *ngIf="loading" class="flex items-center justify-center py-12">
    <div class="text-center">
      <div class="inline-block animate-spin rounded-full h-10 w-10 border-4 border-orange-500 border-t-transparent mb-3"></div>
      <p class="text-gray-600 dark:text-gray-400 text-sm">Carregando frequências...</p>
    </div>
  </div>

  <!-- Error Message -->
  <div *ngIf="errorMessage" class="m-3 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-3">
    <div class="flex items-center gap-2">
      <lucide-icon name="alert-circle" class="w-4 h-4 text-red-500 dark:text-red-400 flex-shrink-0"></lucide-icon>
      <span class="text-red-700 dark:text-red-300 text-sm">{{ errorMessage }}</span>
    </div>
  </div>

  <!-- Warning Message (não exibir quando não houver alunos) -->
  <div *ngIf="warningMessage && !loading && enturmacoes.length > 0" class="m-3 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg p-3">
    <div class="flex gap-2">
      <lucide-icon name="alert-triangle" class="w-4 h-4 text-yellow-600 dark:text-yellow-400 flex-shrink-0 mt-0.5"></lucide-icon>
      <div class="text-yellow-800 dark:text-yellow-300 text-sm leading-relaxed">
        <span [innerHTML]="warningMessage"></span>
        <span *ngIf="warningMessageDetail"><br/>{{ warningMessageDetail }}</span>
      </div>
    </div>
  </div>

  <!-- Content -->
  <div *ngIf="!loading && !errorMessage" class="space-y-1">

    <!-- Barra de Ordenação -->
    <div *ngIf="enturmacoes.length > 0"
         class="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-3 mb-1">
      <div class="flex items-center justify-between">
        <!-- Dropdown de Ordenação -->
        <div class="relative">
          <button
            (click)="toggleOrdenacaoDropdown()"
            class="flex items-center space-x-2 px-3 py-2 bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-300 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-600 transition-all duration-200"
          >
            <lucide-icon [name]="getIconeOrdenacaoAtual()" class="w-4 h-4"></lucide-icon>
            <lucide-icon [name]="ordenacaoDropdownAberto ? 'chevron-up' : 'chevron-down'" class="w-3 h-3"></lucide-icon>
          </button>

          <!-- Dropdown Menu -->
          <div
            *ngIf="ordenacaoDropdownAberto"
            class="absolute left-0 mt-2 w-64 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-xl z-50"
          >
            <div class="py-1">
              <button
                (click)="selecionarOrdenacao('alfabetica', 'asc')"
                [class]="tipoOrdenacao === 'alfabetica' && direcaoOrdenacao === 'asc'
                  ? 'bg-blue-50 dark:bg-blue-900/20 text-blue-700 dark:text-blue-400'
                  : 'text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'"
                class="w-full flex items-center space-x-3 px-4 py-2.5 transition-colors"
              >
                <lucide-icon name="arrow-down-a-z" class="w-4 h-4"></lucide-icon>
                <span class="text-sm">Ordem alfabética A-Z</span>
              </button>
              <button
                (click)="selecionarOrdenacao('alfabetica', 'desc')"
                [class]="tipoOrdenacao === 'alfabetica' && direcaoOrdenacao === 'desc'
                  ? 'bg-blue-50 dark:bg-blue-900/20 text-blue-700 dark:text-blue-400'
                  : 'text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'"
                class="w-full flex items-center space-x-3 px-4 py-2.5 transition-colors"
              >
                <lucide-icon name="arrow-down-z-a" class="w-4 h-4"></lucide-icon>
                <span class="text-sm">Ordem alfabética Z-A</span>
              </button>
              <button
                (click)="selecionarOrdenacao('numeroChamada', 'asc')"
                [class]="tipoOrdenacao === 'numeroChamada' && direcaoOrdenacao === 'asc'
                  ? 'bg-blue-50 dark:bg-blue-900/20 text-blue-700 dark:text-blue-400'
                  : 'text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'"
                class="w-full flex items-center space-x-3 px-4 py-2.5 transition-colors"
              >
                <lucide-icon name="arrow-down-0-1" class="w-4 h-4"></lucide-icon>
                <span class="text-sm">Nº da chamada crescente</span>
              </button>
              <button
                (click)="selecionarOrdenacao('numeroChamada', 'desc')"
                [class]="tipoOrdenacao === 'numeroChamada' && direcaoOrdenacao === 'desc'
                  ? 'bg-blue-50 dark:bg-blue-900/20 text-blue-700 dark:text-blue-400'
                  : 'text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'"
                class="w-full flex items-center space-x-3 px-4 py-2.5 transition-colors"
              >
                <lucide-icon name="arrow-down-1-0" class="w-4 h-4"></lucide-icon>
                <span class="text-sm">Nº da chamada decrescente</span>
              </button>
            </div>
          </div>
        </div>

        <!-- Legenda compacta -->
        <div class="flex items-center space-x-2">
          <div class="flex items-center space-x-1">
            <div class="w-6 h-6 bg-green-500 text-white rounded flex items-center justify-center font-bold text-[11px]">P</div>
            <span class="text-[11px] text-gray-600 dark:text-gray-300">Presença</span>
          </div>
          <div class="flex items-center space-x-1">
            <div class="w-6 h-6 bg-red-500 text-white rounded flex items-center justify-center font-bold text-[11px]">F</div>
            <span class="text-[11px] text-gray-600 dark:text-gray-300">Falta</span>
          </div>
          <div class="flex items-center space-x-1">
            <div class="w-6 h-6 bg-yellow-500 text-white rounded flex items-center justify-center font-bold text-[11px]">D</div>
            <span class="text-[11px] text-gray-600 dark:text-gray-300">Dispensa</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Lista de Alunos — mesmo tamanho e estilo do modo Dia -->
    <div *ngFor="let enturmacao of enturmacoesOrdenadas; trackBy: trackByEnturmacaoId"
         class="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 transition-all duration-200 hover:shadow-lg hover:border-blue-300 dark:hover:border-blue-600">

      <!-- Header do Card (idêntico ao modo Dia) -->
      <div class="p-2"
           [class.cursor-pointer]="hasEnturmacaoAtiva(enturmacao)"
           (click)="hasEnturmacaoAtiva(enturmacao) && toggleCardExpansion(enturmacao)">
        <div class="flex items-center justify-between">

          <!-- Número e Nome -->
          <div class="flex items-center space-x-2 flex-1 min-w-0">
            <span *ngIf="enturmacao.numero"
                  class="text-sm font-bold text-gray-700 dark:text-gray-300 flex-shrink-0 min-w-[1.5rem] text-right">
              {{ enturmacao.numero }}
            </span>
            <span class="text-base text-gray-900 dark:text-gray-100 truncate min-w-0">
              {{ getNomeEnturmacao(enturmacao) }}
            </span>
          </div>

          <!-- Lado direito: ícone abono (sempre) + badge P/F (somente quando enturmado) -->
          <div class="flex items-center space-x-3 flex-shrink-0">

            <!-- Ícone abono/justificativa — sempre visível -->
            <button
                    class="relative w-10 h-10 flex items-center justify-center bg-blue-50 dark:bg-gray-700 hover:bg-blue-100 dark:hover:bg-blue-900 rounded-lg shadow-md transition-all duration-200 hover:scale-110 active:scale-95"
                    (click)="abrirAbono(enturmacao, $event)"
                    appPermissions
                    [appPermissionsAny]="['AbonoFaltaPageMapping', 'JustificativaFaltaPageMapping']"
                    title="Abono / Justificativa">
              <lucide-icon 
                name="files" 
                class="w-5 h-5 transition-colors"
                [ngClass]="getAbonosJustificativasCount(enturmacao) > 0 ? 'text-blue-600 dark:text-blue-400' : 'text-gray-600 dark:text-gray-400'"
              ></lucide-icon>
              
              <!-- Badge com contador de abonos/justificativas -->
              <span 
                *ngIf="getAbonosJustificativasCount(enturmacao) > 0"
                class="absolute -top-1 -right-1 flex items-center justify-center min-w-[18px] h-[18px] bg-blue-600 dark:bg-blue-500 text-white text-[10px] font-bold rounded-full border-2 border-white dark:border-gray-800 px-1"
              >
                {{ getAbonosJustificativasCount(enturmacao) }}
              </span>
            </button>

            <!-- Badge P/F/D — somente quando enturmado -->
            <div *ngIf="hasEnturmacaoAtiva(enturmacao)"
                 class="w-8 h-8 rounded font-bold text-white flex items-center justify-center relative text-xs"
                 [ngClass]="getBadgeClass(enturmacao)">
              <!-- D - Dispensado (todas as aulas dispensadas) -->
              <span *ngIf="isAllDispensado(enturmacao)">D</span>
              <!-- F - Falta (com contador) -->
              <ng-container *ngIf="!isAllDispensado(enturmacao) && getFaltasDoDia(enturmacao) > 0">
                <span>F</span>
                <span class="absolute -top-1 -right-1 flex items-center justify-center min-w-[16px] h-4 bg-red-700 text-white text-[9px] font-bold rounded-full px-0.5 border border-white dark:border-gray-800">
                  {{ getFaltasDoDia(enturmacao) }}
                </span>
              </ng-container>
              <!-- P - Presente -->
              <span *ngIf="!isAllDispensado(enturmacao) && getFaltasDoDia(enturmacao) === 0 && getBadgeClass(enturmacao) === 'bg-green-500'">P</span>
              <!-- ? - Sem registro -->
              <span *ngIf="!isAllDispensado(enturmacao) && getFaltasDoDia(enturmacao) === 0 && getBadgeClass(enturmacao) === 'bg-gray-500'">?</span>
            </div>
          </div><!-- /lado direito -->
        </div>

        <!-- Chevron centralizado (linha própria) — somente quando enturmado -->
        <div *ngIf="hasEnturmacaoAtiva(enturmacao)" class="flex justify-center mt-1">
          <lucide-icon
            [name]="isCardExpandido(enturmacao) ? 'chevron-up' : 'chevron-down'"
            class="w-4 h-4 text-gray-400 dark:text-gray-500">
          </lucide-icon>
        </div>
      </div>

      <!-- Aluno não enturmado: mensagem centralizada -->
      <div *ngIf="!hasEnturmacaoAtiva(enturmacao)"
           class="mx-3 mb-3 flex items-center justify-center gap-2 rounded-lg px-3 py-2 bg-[#F7E7BA] dark:bg-yellow-900/40 dark:border dark:border-yellow-700/60">
        <lucide-icon name="info" class="w-4 h-4 text-yellow-700 dark:text-yellow-400 flex-shrink-0"></lucide-icon>
        <span class="text-xs font-medium text-yellow-900 dark:text-yellow-200">
          O aluno não está enturmado nesta data
        </span>
      </div>

      <!-- Conteúdo Expandido: botões P/F por aula -->
      <div *ngIf="isCardExpandido(enturmacao)"
           class="px-3 pb-3 pt-2 bg-gray-50 dark:bg-gray-900/50 border-t border-gray-200 dark:border-gray-700">

        <div class="grid gap-2"
             [class.grid-cols-3]="aulasDoDia.length <= 3"
             [class.grid-cols-4]="aulasDoDia.length === 4"
             [class.grid-cols-5]="aulasDoDia.length === 5"
             [class.grid-cols-6]="aulasDoDia.length >= 6">

          <div *ngFor="let freq of enturmacao.frequenciasAulas; trackBy: trackByUniqueId"
               class="flex flex-col items-center gap-1">

            <!-- Número da aula com cor da matéria -->
            <div class="flex items-center justify-center gap-1 min-w-0">
              <span class="w-2 h-2 rounded-full flex-shrink-0"
                    [style.background-color]="getCorItemEducacional(freq.alocacaoAula.itemEducacional.id)">
              </span>
              <span
                class="text-[11px] font-medium text-gray-500 dark:text-gray-400 whitespace-nowrap tabular-nums">
                {{ freq.alocacaoAula.numero }}ª aula
              </span>
            </div>

            <!-- Botão P/F/D por aula (ou placeholder quando multiturno: aluno não frequenta aquele horário) -->
            <!-- Cinza (P) = sem registro; Verde (P) = presença explícita; Vermelho (F) = falta; Amarelo (D) = dispensa -->
            <button
              *ngIf="isVisibleButtonFalta(freq) || freq.hasDispensa"
              [disabled]="freq.disabled || !freq.isEnturmado || freq.hasDispensa || periodoFechado || !freq.isChecked"
              class="w-8 h-8 flex items-center justify-center rounded font-bold text-xs shadow-sm transition-all active:scale-95 disabled:opacity-40 disabled:cursor-not-allowed"
              [class.bg-red-500]="!freq.hasDispensa && freq.tipo === 'FALTA'"
              [class.hover:bg-red-600]="!freq.hasDispensa && freq.tipo === 'FALTA' && !freq.disabled && !periodoFechado"
              [class.bg-green-500]="!freq.hasDispensa && freq.tipo === 'PRESENCA'"
              [class.hover:bg-green-600]="!freq.hasDispensa && freq.tipo === 'PRESENCA' && !freq.disabled && !periodoFechado"
              [class.bg-yellow-500]="freq.hasDispensa"
              [class.bg-gray-200]="!freq.hasDispensa && freq.tipo === null"
              [class.dark:bg-gray-600]="!freq.hasDispensa && freq.tipo === null"
              [class.hover:bg-gray-300]="!freq.hasDispensa && freq.tipo === null && !freq.disabled && !periodoFechado"
              [class.text-white]="freq.tipo === 'FALTA' || freq.tipo === 'PRESENCA' || freq.hasDispensa"
              [class.text-gray-500]="!freq.hasDispensa && freq.tipo === null"
              [class.dark:text-gray-300]="!freq.hasDispensa && freq.tipo === null"
              (click)="toggleFalta(freq, enturmacao)">
              <ng-container *ngIf="freq.hasDispensa">D</ng-container>
              <ng-container *ngIf="!freq.hasDispensa && freq.tipo === 'FALTA'">F</ng-container>
              <ng-container *ngIf="!freq.hasDispensa && freq.tipo === 'PRESENCA'">P</ng-container>
              <ng-container *ngIf="!freq.hasDispensa && freq.tipo === null">?</ng-container>
            </button>
            <!-- Mesmo tamanho do botão: indica slot não aplicável ao turno do aluno (multiturno) — alinhado ao AngularJS (span "-") -->
            <div
              *ngIf="!isVisibleButtonFalta(freq) && !freq.hasDispensa"
              class="w-8 h-8 flex items-center justify-center rounded border border-dashed border-gray-300 dark:border-gray-600 bg-gray-100/80 dark:bg-gray-800/80 text-gray-400 dark:text-gray-500 text-xs font-bold select-none"
              [attr.title]="getTituloSlotTurnoNaoAplicavel()"
              [attr.aria-label]="getTituloSlotTurnoNaoAplicavel()">
              —
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- Empty State -->
    <div *ngIf="enturmacoesCarregadas && enturmacoes.length === 0 && !loading"
         class="bg-white dark:bg-gray-800 rounded-lg p-8 text-center border border-gray-200 dark:border-gray-700 m-3">
      <lucide-icon name="users" class="w-12 h-12 text-gray-300 dark:text-gray-600 mx-auto mb-3"></lucide-icon>
      <p class="text-gray-500 dark:text-gray-400 text-sm font-medium">Nenhum aluno encontrado</p>
      <p class="text-gray-400 dark:text-gray-500 text-xs mt-1">
        Verifique se há alunos matriculados na turma e período selecionados.
      </p>
    </div>
  </div>
</div>
